import { FC } from "react";

import styled from "@emotion/styled";
import {
  ANDROID_APP_DOWNLOAD_LINK,
  APP_DOWNLOAD_QR_URL,
  IOS_APP_DOWNLOAD_LINK
} from "src/constants/misc";
import appStore from "src/ui/assets/logos/app_store.png";
import googlePlay from "src/ui/assets/logos/google_play.png";
import Qrcode from "src/ui/components/Qrcode/Qrcode";
import Translate from "src/ui/components/Translate/Translate";

import MealHeroBackground from "./MealHeroBackground";

const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 1.5rem;
  width: 100%;
  padding: 19.5rem 1.5rem 1.5rem;
  border-radius: 0.5rem;
  overflow: hidden;
  background-color: var(--color-cream, #fffcf3);
  box-shadow:
    -3px 2px 4px rgba(247, 189, 230, 0.17),
    -53px 26px 12px rgba(247, 189, 230, 0.04);
`;

const Header = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 7px;
  width: 100%;
  text-align: center;
  color: var(--color-charcoal, #212121);
`;

const Title = styled.h2`
  margin: 0;
  font-family: "STK Bureau Serif", serif;
  font-size: 2.5rem;
  font-weight: 300;
  line-height: 2.75rem;
  letter-spacing: -1px;
`;

const Description = styled.p`
  margin: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.375;
  letter-spacing: -0.32px;
`;

const DownloadBox = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 8px 12px 8px 8px;
  border-radius: 0.5rem;
  background: rgba(255, 255, 255, 0.3);
`;

const QrSlot = styled.div`
  flex-shrink: 0;
  width: 90px;
`;

const DownloadInfo = styled.div`
  flex: 1 0 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const DownloadText = styled.p`
  margin: 0;
  color: var(--color-charcoal, #212121);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  letter-spacing: -0.28px;
`;

const StoreBadges = styled.div`
  display: flex;
  align-items: center;
  gap: 9.6px;
`;

const BadgeLink = styled.a`
  display: inline-flex;
`;

const Badge = styled.img`
  height: 24px;
  width: auto;
  max-width: unset;
`;

const MealInsightsDesktopPromo: FC = () => (
  <Card>
    <MealHeroBackground />
    <Header>
      <Title>
        <Translate msg="mealInsights.ftux.desktop.title" />
      </Title>
      <Description>
        <Translate msg="mealInsights.ftux.desktop.description" />
      </Description>
    </Header>
    <DownloadBox>
      <QrSlot>
        <Qrcode size={90} text={APP_DOWNLOAD_QR_URL} />
      </QrSlot>
      <DownloadInfo>
        <DownloadText>
          <Translate msg="mealInsights.ftux.desktop.qr" />
        </DownloadText>
        <StoreBadges>
          <BadgeLink
            href={IOS_APP_DOWNLOAD_LINK}
            target="_blank"
            rel="noreferrer"
          >
            <Badge src={appStore} alt="Download on the App Store" />
          </BadgeLink>
          <BadgeLink
            href={ANDROID_APP_DOWNLOAD_LINK}
            target="_blank"
            rel="noreferrer"
          >
            <Badge src={googlePlay} alt="Get it on Google Play" />
          </BadgeLink>
        </StoreBadges>
      </DownloadInfo>
    </DownloadBox>
  </Card>
);

export default MealInsightsDesktopPromo;
